import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import PrintStyles from "../../../../../css/PrintPDFs/PrintStyles.js";
import logo from "../../../../../assets/images/logo/logo-with-title.png";
import dayjs from "dayjs";

/**
 * Renders the Applicant Reference Consent Form as a PDF document using react-pdf components.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.printName - The name of the applicant to be printed on the form.
 * @param {Object|string} props.printNameDate - The date associated with the applicant's signature. Can be a Firestore Timestamp object or a date string.
 * @param {string} props.printNameSignature - The URI or base64 string of the applicant's signature image.
 * @returns {JSX.Element} The rendered PDF document for the reference consent form.
 *
 * @example
 * <ReferencesConsentForm
 *   printName="John Doe"
 *   printNameDate={new Date()}
 *   printNameSignature="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA..."
 * />
 */
const ReferencesConsentForm = ({
  printName = "",
  printNameDate = "",
  printNameSignature = "",
}) => {
  const styles = PrintStyles;
  const formatDate = new Date().toLocaleDateString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.row}>
          <Image style={styles.image} src={logo} />
          <View style={styles.column}>
            <Text style={styles.subcontent}>Our Address</Text>
            <Text style={styles.content}>
              Rosemount House, 2 – 4 Chequers Road
            </Text>
            <Text style={styles.content}>Basingstoke, RG21 7PU</Text>
            <Text style={styles.subcontent}>Phone</Text>
            <Text style={styles.content}>01256 405460</Text>
            <Text style={styles.subcontent}>Our Website</Text>
            <Text style={styles.content}>https://rosemountfs-ifa.co.uk/</Text>
          </View>
        </View>
        <View style={styles.divider}></View>
        <View style={styles.sizedBox} />
        <Text style={styles.contentBoldUnderline}>
          Applicant Reference Consent Form
        </Text>
        <View style={styles.table}>
          {/* <View style={styles.tableRow}>
            <Text style={[styles.tableHeader, { flex: 2 }]}>Risk Rating</Text>
            <Text style={[styles.tableHeader, { flex: 4 }]}>Description</Text>
          </View> */}

          <View style={[styles.tableRow]}>
            <Text style={styles.smallCell}>Referee Name</Text>
            <Text style={styles.largeCell}>Leilah Sadat</Text>
          </View>

          <View style={[styles.tableRow]}>
            <Text style={styles.smallCell}>Company Name</Text>
            <Text style={styles.largeCell}>
              Rosemount Financial Solutions (IFA) Ltd
            </Text>
          </View>

          <View style={[styles.tableRow]}>
            <Text style={styles.smallCell}>Company FCA Number</Text>
            <Text style={styles.largeCell}>535515</Text>
          </View>
        </View>
        <View style={styles.sizedBox} />
        <Text style={styles.content}>
          My signature below authorises my former employers and referees to
          release information regarding my employment record with Rosemount
          Financial Solutions (IFA) Ltd and to provide any additional
          information that may be necessary for my application for employment
          with them.
        </Text>
        <View style={styles.sizedBox} />
        <Text style={styles.content}>
          I understand and acknowledge that any offer of appointment is
          conditional to Rosemount Financial Solutions (IFA) Ltd being
          completely satisfied with the information provided by these
          references.
        </Text>
        <View style={styles.sizedBox} />
        <View style={styles.table}>
          {/* <View style={styles.tableRow}>
            <Text style={[styles.tableHeader, { flex: 2 }]}>Risk Rating</Text>
            <Text style={[styles.tableHeader, { flex: 4 }]}>Description</Text>
          </View> */}

          <View style={[styles.tableRow, { minHeight: 50 }]}>
            <Text style={styles.smallCell}>Signed</Text>
            <Text style={styles.largeCell}>
              {printNameSignature ? (
                <Image
                  source={{ uri: printNameSignature }}
                  style={styles.image}
                  //   style={{ width: 100, height: 40, resizeMode: 'contain' }}
                />
              ) : (
                ""
              )}
            </Text>
          </View>

          <View style={[styles.tableRow]}>
            <Text style={styles.smallCell}>Print Name</Text>
            <Text style={styles.largeCell}>{printName || ""}</Text>
          </View>

          <View style={[styles.tableRow]}>
            <Text style={styles.smallCell}>Date</Text>
            <Text style={styles.largeCell}>
              {printNameDate
                ? dayjs(printNameDate.seconds * 1000).format("DD/MM/YYYY") ||
                  dayjs(printNameDate).format("DD/MM/YYYY")
                : ""}
            </Text>
          </View>
        </View>
        <View style={styles.footer}>
          <View style={styles.divider}></View>
          <Text style={styles.contentSmall}>
            Rosemount Financial Solutions (IFA) Ltd is an authorised and
            regulated by the Financial Conduct Authority. Registered as a
            Limited Company in England & Wales No 05668905. Registered Address:
            Rosemount House, 2-4 Chequers Road, Basingstoke, RG21 7PU.
          </Text>
        </View>
      </Page>
    </Document>
  );
};
export default ReferencesConsentForm;
